import { ETimeUnit } from '@/constants';

import getFromDate from './getFromDate';

const getHoursFromDate = getFromDate(ETimeUnit.hour);

export default getHoursFromDate;
